import React from 'react';
import { Button } from 'junto-ui';
import { PageTitle } from 'components-core';
import { useStore } from '@store';
import BoxWithMargin from '../../BoxWithMargin';
import OfflineIllustration from '../../../../assets/images/OfflineIllustration';

export default () => {
  const sharedStore = useStore('sharedStore');

  return (
    <>
      <OfflineIllustration />
      <BoxWithMargin
        desktop={{ bottom: '40px', top: '40px' }}
        responsive={{ bottom: '24px', top: '24px' }}
      >
        <PageTitle maxWidth="448px">
          Parece que sua conexão não está respondendo. Verifique a rede e tente novamente.
        </PageTitle>
      </BoxWithMargin>
      <BoxWithMargin
        desktop={{ bottom: '32px' }}
        responsive={{ bottom: '24px' }}
        desktopWidth="100%"
        responsiveWidth="100%"
      >
        <Button variant="primary" size="big" onClick={() => sharedStore.clearErrors()}>
          Tentar novamente
        </Button>
      </BoxWithMargin>
    </>
  );
};
